import _                   from 'lodash'
import { applyMiddleware } from 'redux'
import thunkMiddleware     from 'redux-thunk'
import promiseMiddleware   from 'redux-promise-middleware'

isPromise     = (obj) -> _.isObject(obj) and _.isFunction(obj.then)
swallowErrors = ['NotFoundError', 'BadRequestError', 'ForbiddenError', 'PreconditionFailed']

# swallows errors for all rejected promise-actions - these are handled in reducers
export swallowErrorsMiddleware = ->
  (next) -> (action) ->
    return next(action) unless isPromise(action.payload)

    next(action).catch (error) ->
      throw error unless error.name in swallowErrors

export defaultMiddleware =
  applyMiddleware(thunkMiddleware, swallowErrorsMiddleware, promiseMiddleware)

export class Reducer
  prefix: ''
  initialState: {}

  dispatch: (state, action, args...) =>
    state ?= @initialState
    prefix = new RegExp('^' + @prefix + '_?')
    method = @[_.camelCase(action.type.replace(prefix, ''))]

    if method then method.bind(@)(state, action, args...) else state

  @dispatch: (state, action, args...) ->
    (new @).dispatch(state, action, args...)

export dispatchToProps = (actionCreators) ->
  (dispatch) ->
    _.mapValues(actionCreators, (creator) -> (args...) -> dispatch(creator(args...)))
